<template>
  <section class="container">
    <div
      v-if="isLoading"
      class="skeleton-load"
      style="width: 100%; min-height: 50vh; border-radius: 16px; margin: 3rem auto;"
    ></div>
    <div class="banner" v-if="!isLoading">
      <div class="banner-left">
        <h1 class="display-4 banner-title">{{ banner.title }}</h1>
        <p class="lead banner-copy">{{ banner.description }}</p>
        <span v-if="false">
          <p>Introducción a Git en:</p>
          <div class="banner-call-to-actions">
            <div class="input-group">
              <div class="countdown-component-container">
                <div class="countdown-component">
                  <div class="countdown-component-item">
                    <span>4</span>
                    <span>días</span>
                  </div>
                  <div class="countdown-component-item">
                    <span>3</span>
                    <span>horas</span>
                  </div>
                  <div class="countdown-component-item">
                    <span>30</span>
                    <span>minutos</span>
                  </div>
                  <div class="countdown-component-item">
                    <span>58</span>
                    <span>segundos</span>
                  </div>
                </div>
              </div>
              <div class="input-group-append">
                <button class="input-group-text btn-primary">
                  <i class="fa fa-calendar" style="margin-right: .35rem;"></i>
                  Agendar
                </button>
              </div>
            </div>

            <!-- <a class="btn btn-primary" href="#" role="button">Suscríbete</a> -->
          </div>
        </span>
      </div>
      <div class="banner-image">
        <img :src="banner.image" alt />
      </div>
    </div>
  </section>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "Banner",
  data() {
    return {
      banner: {},
      isLoading: true
    };
  },
  created() {
    (async () => {
      try {
        this.banner = await firebase
          .database()
          .ref("banner/")
          .once("value")
          .then(snapshot => snapshot.val());
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    })();
  }
};
</script>